import { PageLayout } from './utils/util';
import { useState, useEffect } from 'react';
import { api } from './utils/api';
import './styles/About.css'

const AboutPage: React.FC = () => {
    const [imageSrc, setImageSrc] = useState('/assets/images/about.jpg');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const response = await api.get('/api/image-url?key=David%20Wallach_FINAL.jpg');
                if (!response.ok) {
                    throw new Error('Failed to fetch image');
                }
                const data = await response.json();
                setImageSrc(data.url);
            } catch (err: any) {
                setError(err.message);
            }
        };

        fetchImage();
    }, []);

    return (
        <PageLayout title="About the Photographer">
            {error && <p>Error loading image: {error}</p>}
            {imageSrc ? (
                <img src={imageSrc} alt="About the Photographer" style={{ width: '100%' }} />
            ) : (
                <p>Loading image...</p>
            )}
            <p style={{ textAlign: 'right' }}>
                Photo credit <a href="https://www.robertkalmanweb.com/" target="_blank" rel="noopener noreferrer">Robert Kalman</a>
            </p>
            <section id="about" className="dw-about">
                <div className="dw-about-inner">
                    <p>
                        I’ve been taking photos since I moved to the city in 2017, but I started to take it more seriously in 2020. I needed a reason to go outside and photography seemed like the right fit. Whether I’m shooting film or digital, friends or strangers, I love capturing the fleeting moments of interaction that I see around me everyday.
                    </p>
                    <p>
                        I have had an interest in portraiture, particularly using strobes, since I started shooting but taking a class at the International Photography Center changed my horizons. I am now confident that with my equipment and a given little time I can take a good photo of anyone, even those who think they aren’t photogenic. These are the most rewarding people to photograph as I can really affect how they see themselves.
                    </p>
                    <p>
                        If you would like a portrait or for me to take photos at an event please contact me via email or social media to discuss rates. For something more casual come find me on the weekend in Washington Square Park where I make high quality portraits on Fujifilm Instax.
                    </p>
                </div>
            </section>
        </PageLayout>
    );
};

export default AboutPage;